import { createSlice } from "@reduxjs/toolkit";
import { getEnvValueFor } from "../../../helpers/utils";

interface DashboardWidgetMeta {
  key: string;
  url: string;
  requires_fetch: boolean;
  widget_type: string | null;
}

interface Dashboard {
  label: string;
  identifier: string;
  api_path: string;
  visibility: string;
  widgets?: DashboardWidgetMeta[];
  has_ticker_query?: boolean;
}

const fallbackDashboard: Dashboard = {
  label: "Sales",
  identifier: "vantage.sales",
  api_path: "sales",
  visibility: "visible",
};

const initialState = {
  dashboards: [] as Dashboard[],
  defaultDashboard: null as Dashboard | null,
  shouldDisableDashboardUpdatedEvents: JSON.parse(
    getEnvValueFor("DISABLE_DASHBOARD_AUTO_PUSH") || "false"
  ),
  pollingInterval:
    parseInt(getEnvValueFor("DASHBOARD_POLL_INTERVAL") || "9") * 1000,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardsList(state, action: { payload: Dashboard[] }) {
      state.dashboards = action.payload;
      state.defaultDashboard =
        action.payload.find((d) => d.visibility == "visible") ??
        fallbackDashboard;
    },
  },
});

export const { setDashboardsList } = dashboardSlice.actions;
export const reducer = dashboardSlice.reducer;
